import axios from "axios";

const instance = axios.create({
  auth: {
    username: 'altinkaynak',
    password: 's*gdhdh35'
  }});

  instance.interceptors.response.use(null, error => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    //toast.error("An unexpected error occurrred.");
  }
  return Promise.reject(error);
});

const httpService = {
  get: instance.get,
  post: instance.post,
  put: instance.put,
  delete: instance.delete
};

export default httpService;


